// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-518819bc] {\n  height: calc(100vh - 130px);\n  overflow-y: auto;\n  padding: 10px;\n}", ""]);
// Exports
module.exports = exports;
